module.exports = __webpack_public_path__ + "img/pic9.7a3bad64.png";